import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import NiceModal from "@ebay/nice-modal-react";
import axios from 'axios';
import CookiesModal from '../../components/Modal/CookiesModal';
import {accessibilityRoute, API, buildDataServerAuthorizationHeaders,} from '../../constants/ApiRoutes';
import {useStoreState} from '../../store/hooks';
import {StContactContainer, StContactText, StContactTitle, StyledIcon} from "./MiniFooter.style";

interface AdditionalConfig {
  phoneNumberTitle: string;
  phoneNumber: string;
  emailTitle: string;
  email: string;
}

const MiniFooterComponent: FunctionComponent = () => {
  const currentTranslation = useStoreState(state => state.intl.locale);
  const [additionalConfig, setAdditionalConfig] = React.useState<
    AdditionalConfig
  >();

  const translateAccessibility = (
    <FormattedMessage id={'footer.Accessibility'} />
  );
  const translateLegal = <FormattedMessage id={'footer.Legal'} />;
  const translateContactEmail = <FormattedMessage id={'footer.ContactEmail'} />;
  const translateEmail = <FormattedMessage id={'footer.Email'} />;
  const translateCookies = <FormattedMessage id={'footer.cookies'} />;

  const date = new Date();
  const curYear = date.getFullYear();
  const legalNoticeUrl = "https://usl.safe.socgen/documents/170256/1075160/version+janvier+2024+MyBuilding+CGU+Mentions+l%C3%A9gales+r%C3%A9vision+du+01+07+19+valid%C3%A9+24+01+24.pdf/252c4d0d-4b35-8372-bf98-a96f3997912a?t=1706288329898";

  async function getAdditionalConfig() {
    await axios(
      `${API.INTRANET.GET_ADDITIONAL_CONFIG}?lang=${currentTranslation}`,
      {
        headers: buildDataServerAuthorizationHeaders(),
      },
    )
      .then(response => {
        setAdditionalConfig(response.data.result);
      })
      .catch(error => {
        alert(`get additional config ERROR : ${error}`);
      });
  }

  React.useEffect(() => {
    getAdditionalConfig();
  }, [currentTranslation]);

  return (
    <footer className="sgbs-footer-light border-top justify-content-between p-3">
      <div className="d-flex justify-content-center">
        <StContactContainer className="d-flex">
          <StyledIcon className={`icon icon-md`}>mail_outlined</StyledIcon>
          <div>
            <StContactTitle>
              {additionalConfig
                ? additionalConfig.emailTitle
                : translateContactEmail}
            </StContactTitle>
            <StContactText>
              {additionalConfig ? additionalConfig.email : translateEmail}
            </StContactText>
          </div>
        </StContactContainer>
      </div>
      <div className="d-flex justify-content-between">
        <span className="sgbs-footer-item h6 mb-0 fw-normal">© Societe Generale Group {curYear}</span>
        <ul className="list-unstyled d-flex mb-0">
          <li className="ms-3">
            <Link className="sgbs-footer-item h6 mb-0 fw-normal" to={accessibilityRoute}>{translateAccessibility}</Link>
          </li>
          <li className="ms-3">
            <a className="sgbs-footer-item h6 mb-0 fw-normal" target="_blank" rel="noopener noreferrer" href={legalNoticeUrl}>
              {translateLegal}
            </a>
          </li>
          <li className="ms-3">
            <button className="sgbs-footer-item h6 mb-0 fw-normal bg-transparent"
                    onClick={() => {
                      NiceModal.show(CookiesModal).then();
                    }}>
              {translateCookies}
            </button>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default MiniFooterComponent;
